import React, { Component } from 'react'
import axios from 'axios'
import './DirectMatchVendor.css'
import { constants } from '../../constants'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { logActivity } from '../Utilities'
var raw_suggestion = []
var raw_manual = []
var raw_input = []

class DirectMatchVendor extends Component {

    constructor(props) {
        super(props)

        this.state = {
            fetched_data: [],
            input: [],
            status: 0,
            search: [],
            loader: false
        }
    }

    componentDidMount = () => {
        // logActivity([
        //     {
        //         'screen': 'Direct Match Vendor',
        //         'module': 'Vendor Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Vendor Cleaning"
        document.getElementById("header").style.opacity = "0.5"

        // Data to feed to API

        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "collection_name": "direct_match_ven",
            "key": "vendor"
        }

        // Call API
        this.setState({
            loader: true
        }, () => {
            axios.post(Urls.dataset.fetch, body)
                .then(response => {
                    this.setState({
                        fetched_data: response.data.data,
                        search: response.data.search,
                        loader: false
                    }, () => { if (this.state.fetched_data.length === 0) { this.props.history.push({ pathname: "/spellCorrectionVendor" }) } })
                    document.getElementById("header").style.opacity = "1"

                    var i;

                    // Initializing suggestion json to Accepted

                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        raw_suggestion.push({
                            "suggestion": "Accepted"
                        })
                    }
                    raw_input.push(raw_suggestion)

                    // Initializing manual json to blank 
                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        raw_manual.push({
                            "manual": ""
                        })
                    }
                    raw_input.push(raw_manual)

                    this.setState({
                        input: raw_input
                    })
                })
                .catch(error => {
                    this.setState({ loader: false })
                    console.log(error)
                })
        })

    }

    selectChangeHandler = event => {
        this.setState({ status: 1 })
        // Check index for raw_suggestion list
        var index = event.target.name
        var index_value = event.target.value
        if (index_value === "Rejected") {
            raw_suggestion[index] = { "suggestion": "Rejected" }
            document.getElementById(index).disabled = false
            document.getElementById(event.target.name).required = true
            document.getElementById(index).style.border = "1px solid royalblue"
        }
        else {
            raw_manual[index] = { "manual": "" }
            raw_suggestion[index] = { "suggestion": "Accepted" }
            document.getElementById(index).disabled = true
            document.getElementById(event.target.name).required = false
            document.getElementById(index).style.border = "none"
        }

    }

    manualChangeHandler = event => {
        var index = event.target.id
        var manual_entry = event.target.value
        raw_manual[index] = {
            "manual": manual_entry
        }
    }

    submitHandler = (e) => {
        var emptyRows = []
        e.preventDefault()

        var body = {};

        if (this.state.status === 1) {

            raw_input = []
            raw_input.push(raw_suggestion)
            raw_input.push(raw_manual)
            this.setState({
                input: raw_input
            })
            body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "collection_name": "direct_match_ven",
                "key": "vendor",
                "input": raw_input
            }
        }
        else {
            // logActivity([
            //     {
            //         'screen': 'Direct Match Vendor',
            //         'module': 'Vendor Cleaning',
            //         'user_activity': 'data submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            this.setState({
                input: raw_input
            })
            body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "collection_name": "direct_match_ven",
                "key": "vendor",
                "input": raw_input
            }
        }
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
            if (raw_suggestion[i]['suggestion'] === "Rejected") {
                if (new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    emptyRows.push(`Row: ${i + 1}`)
                    document.getElementById(i).style.border = '1px solid red'
                }
            }
        }
        if (emptyRows.length === 0) {
            document.getElementById("header").style.opacity = "0.5"
            this.setState({
                loader: true
            }, () => {
                axios.post(Urls.dataset.dump, body)
                    .then(response => {
                        console.log(response)
                        document.getElementById("header").style.opacity = "1"
                        this.setState({ loader: false })
                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                        this.props.history.push({
                            pathname: "/spellCorrectionVendor"
                        })
                    })
                    .catch(error => {
                        this.setState({ loader: false })
                        console.log(error)
                    })
            })
        }
        else {
            alert('Please enter vendor name')
        }

    }


    goBack = () => this.props.history.push({ pathname: "/manualLocation" })

    render() {
        const vendors = this.state.fetched_data
        const search_data = this.state.search
        return (
            <div id="header">
                <Loader isLoading={this.state.loader} />
                <div className="container">
                    <div style={{ "margin-bottom": "5%" }} >
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Raw Vendor Name</th>
                                            <th>Vendor Name</th>
                                            <th>Mark as Incorrect</th>
                                            <th>User Input</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            vendors.map((vendor, i) => <tr>
                                                <td> {i + 1} </td>
                                                <td>
                                                    {vendor.Vendor}
                                                </td>
                                                <td>
                                                    {vendor.Map}
                                                </td>
                                                <td>
                                                    <select name={i} data-suggestion="Accepted" onChange={this.selectChangeHandler}>
                                                        <option value="Accepted" >Accepted</option>
                                                        <option value="Rejected" >Rejected</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input className="form-control" required list="auto_complete" disabled type="text" id={i} name={i} onChange={this.manualChangeHandler} placeholder="Vendor Name" />
                                                    <datalist id="auto_complete" >
                                                        {
                                                            search_data.map((e, i) => <option key={i} value={e}> {e} </option>)
                                                        }
                                                    </datalist>
                                                </td>
                                            </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="58%" />
                </div>
            </div>
        )
    }
}

export default DirectMatchVendor
